import data from "../../.sourceflow/tile_groups.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const tile_groups_helper = new CollectionHelper(data);
